import { actionKitImpFunction } from '../../../../../components/ozmoit/common';
import { baseToSelectOption } from '../../../../academicOffers/courses/utils';
import { createSessionRequest, getFormDataRequest } from '../api';
import { StudentRiskEvaluationSessionResponse } from '../types';

const getFormDataAction = actionKitImpFunction(async () => {
  const response = await getFormDataRequest();
  if (response.error) {
    throw new Error('Error fetching form data');
  }

  const { data } = response;
  const years = Array.from(
    new Set(data?.periods?.map((row) => row?.academicYear)),
  ).map((year) => ({
    name: `${year}`,
    id: year,
  }));

  return {
    years: baseToSelectOption(years),
    periods: baseToSelectOption(data?.periods),
    schools: baseToSelectOption(data?.schools),
  };
});

const createSessionAction = actionKitImpFunction(
  async (data: StudentRiskEvaluationSessionResponse) => {
    const response = await createSessionRequest(data);
    if (response.error) {
      throw new Error(response.error?.data?.message ?? 'SAVING_ERROR');
    }
    return response.data;
  },
);

export { getFormDataAction, createSessionAction };
